export { default as ShareModal } from './Modal';
